import {
  RETRIEVE_CONTACTS,
  RETRIEVE_CONTACT_VIEW,
  UPDATE_CONTACT_STATUS,
} from "../actions/types";

const initialState = { contacts: [], totalContactCount: 0, contactDetail: null };

const contactReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RETRIEVE_CONTACTS:
      return {
        ...state,
        contacts: payload.rows,
        totalContactCount: payload.count,
      };

    case RETRIEVE_CONTACT_VIEW:
      return {
        ...state,
        contactDetail: payload,
      };

    case UPDATE_CONTACT_STATUS:
      return {
        ...state,
        contacts: state.contacts.map((contact) =>
          contact.id === payload.id ? { ...contact, status: payload.status } : contact
        ),
        contactDetail: state.contactDetail && state.contactDetail.id === payload.id
          ? { ...state.contactDetail, status: payload.status }
          : state.contactDetail,
      };

    default:
      return state;
  }
};

export default contactReducer;

